import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export const gpuToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.GPU_ATTACH, () => labelOnly("Attached a GPU")],
  [HOST_TOOL_NAMES.GPU_PUSH, () => labelOnly("Sent files to the GPU")],
  [HOST_TOOL_NAMES.GPU_EXEC, () => labelOnly("Ran a command on the GPU")],
  [HOST_TOOL_NAMES.GPU_PULL, () => labelOnly("Fetched files from the GPU")],
  [HOST_TOOL_NAMES.GPU_STATUS, () => labelOnly("Checked the GPU")],
  [HOST_TOOL_NAMES.GPU_DETACH, () => labelOnly("Released the GPU")],
  [HOST_TOOL_NAMES.NOTEBOOK_OPEN, () => labelOnly("Opened JupyterLab")],
  [HOST_TOOL_NAMES.NOTEBOOK_RUN, () => labelOnly("Ran a notebook")],
  [HOST_TOOL_NAMES.NOTEBOOK_STATUS, () => labelOnly("Checked a notebook run")],
  [
    HOST_TOOL_NAMES.GPU_KERNEL_CONNECT,
    () => labelOnly("Switched the notebook to the GPU"),
  ],
  [
    HOST_TOOL_NAMES.GPU_KERNEL_DISCONNECT,
    () => labelOnly("Switched the notebook back to the CPU"),
  ],
];
